<template>
  <div class="o-dataprotection">
    <div class="o-container o-container--large">
      <section>
        <translation-tags path="dataProtection.intro" />
      </section>

      <translation-tags path="dataProtection.informations" />
    </div>
  </div>
</template>

<script>
import TranslationTags from '@/components/TranslationTags'

export default {
  name: 'DataProtection',
  components: {
    TranslationTags
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/variables.scss';

$dataprotection-margin: $component-margin !default;

.o-dataprotection {
  margin: $dataprotection-margin;
}
</style>
